import ProductLayout from '../components/ProductLayout';

export default class DynamicProduct {
  constructor(section) {
    const { el } = section;
    const { product } = section.data;
    const variantAvailable = section.data.variant_available;
    const moneyFormat = section.data.money_format;
    const textStrings = section.data.text_strings;
    const settings = section.data.settings;

    this.productLayout = null;

    if (!product) {
      return;
    }

    this.productLayout = new ProductLayout({
      el,
      moneyFormat,
      product,
      variantAvailable,
      settings,
      textStrings,
    });
  }

  onSectionUnload() {
    if (this.productLayout) {
      this.productLayout.unload();
    }
  }
}
